/**
 * @Author: Jon Lucas
 * @Date:   2017-09-11T16:29:30+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-11T18:17:45+02:00
 */

import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { Http } from "@angular/http";
import { AbstractComponent } from "../abstract-component/abstract.component";
import { AppLoadingStateService } from "../app-loading-state.service";
import { ApiUtils } from "../util/ApiUtils";
import { environment } from "../../environments/environment";

@Component({
    selector: "app-main-view",
    templateUrl: "./main-view.component.html",
    styleUrls: ["./main-view.component.scss"]
})
export class MainViewComponent extends AbstractComponent implements AfterViewInit
{
    public readonly TAG: string = "[MainViewComponent]";

    @ViewChild('mainView') private mainViewElement: ElementRef;

    constructor(protected http: Http, private appLoadingStateService: AppLoadingStateService, private apiUtils: ApiUtils) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
    }

    public ngAfterViewInit(): void {
        this.appLoadingStateService.mainViewLoaded = true;
    }

    public getMainViewElement() {
        return this.mainViewElement;
    }
}



// WEBPACK FOOTER //
// ./src/app/main-view/main-view.component.ts